/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum UserConfirmAliases {
  LOADER_CONF_USER = 'loader-conf-user',
  PANEL_CONF_USER = 'panel-conf-user',
}
export { UserConfirmAliases };
